import * as React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import RadioButtonTile from "./RadioButtonTile";

import styles from "./RadioButtonTileGroup.module.scss";

const RadioButtonTileGroup = ({
  onKeyDown,
  onSelect,
  selectedAnswerIndex,
  classes,
  imagePrefix,
  options,
  liveRegion,
  questionID,
  tabIndex,
  entered,
  leaving,
  isEmbedded,
  fieldValidationError,
}) => (
  <div
    role="radiogroup"
    aria-labelledby={questionID}
    className={classNames(styles.radioButtonTileGroup, {
      [styles.radioButtonTileGroupEmbedded]: isEmbedded,
      [styles.radioButtonTileGroupTwoOptions]: options.length === 2,
      [styles.radioButtonTileGroupWithSelection]:
        typeof selectedAnswerIndex === "number",
      [styles.radioButtonTileGroupStaggeredAnimation]:
        options.length === 3 && selectedAnswerIndex !== 1,
      [classes.options]: classes.options,
      [styles.radioButtonTileGroupEntered]: entered,
      [styles.radioButtonTileGroupLeaving]: leaving,
    })}
  >
    {!!options.length &&
      options.map((item, index) => {
        const isSelectedAnswer = selectedAnswerIndex === index;
        const {
          option: { caption: text, image, imageAlt, value },
          ref,
        } = item;

        return (
          <RadioButtonTile
            index={index}
            radioGroupLength={options.length}
            isSelectedAnswer={isSelectedAnswer}
            onKeyDown={onKeyDown}
            onSelect={onSelect}
            text={text}
            image={image}
            prefix={imagePrefix}
            imageAlt={imageAlt}
            value={value}
            optionRef={ref}
            className={classNames(classes.option, styles.radioButtonTileChild, {
              [styles.radioButtonTileChildEmbedded]: isEmbedded,
              [styles.radioButtonTileChildChecked]: isSelectedAnswer,
            })}
            liveRegion={liveRegion}
            key={text}
            tabIndex={tabIndex}
            isEmbedded={isEmbedded}
            fieldValidationError={fieldValidationError}
            questionID={questionID}
          />
        );
      })}
  </div>
);

export default RadioButtonTileGroup;

RadioButtonTileGroup.defaultProps = {
  classes: {},
  fieldValidationError: false,
  isEmbedded: false,
  selectedAnswerIndex: null,
};

RadioButtonTileGroup.propTypes = {
  onKeyDown: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  selectedAnswerIndex: PropTypes.number,
  classes: PropTypes.shape({
    option: PropTypes.string,
    options: PropTypes.string,
  }),
  imagePrefix: PropTypes.string.isRequired,
  isEmbedded: PropTypes.bool,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      option: PropTypes.shape({
        caption: PropTypes.string.isRequired,
        description: PropTypes.string.isRequired,
        image: PropTypes.string.isRequired,
        imageAlt: PropTypes.string.isRequired,
      }).isRequired,
      ref: PropTypes.oneOfType([
        PropTypes.shape({
          current: PropTypes.instanceOf(PropTypes.Element),
        }),
        PropTypes.func,
      ]).isRequired,
    })
  ).isRequired,
  liveRegion: PropTypes.string.isRequired,
  questionID: PropTypes.string.isRequired,
  tabIndex: PropTypes.string.isRequired,
  entered: PropTypes.bool.isRequired,
  leaving: PropTypes.bool.isRequired,
  fieldValidationError: PropTypes.bool,
};
